var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { validateEmail } from '../../common';
import { isNotIncludedEmailDomain } from '../../utils';
import { validateAccountStatus, validateAdminAccountStatus, } from './proffit_search_common_validate';
const memberValidate = (values, dispatch, formProp, fieldName) => __awaiter(void 0, void 0, void 0, function* () {
    const { changeEmailStates, syncErrors, unMountRef } = formProp;
    const promiseList = (values.members || [])
        .filter((member, key) => {
        const membersError = syncErrors.members || [];
        return !membersError[key];
    })
        .map((member) => validateAccountStatus(dispatch, member.email, fieldName));
    const result = yield Promise.all(promiseList);
    if (unMountRef.current) {
        return;
    }
    const updateEnableStates = {};
    result
        .filter((v) => v.hasEnableAccount)
        .forEach((v) => {
        updateEnableStates[v.email] = true;
    });
    const updateError = { members: [] };
    result
        .filter((v) => v.error)
        .forEach((v) => {
        const memberIndex = values.members.findIndex((findValue) => findValue.email === v.email);
        updateError.members[memberIndex] = { email: v.error };
    });
    changeEmailStates(updateEnableStates);
    if (Object.keys(updateError).length > 0) {
        throw updateError;
    }
});
const adminValidate = (values, dispatch, formProp, fieldName) => __awaiter(void 0, void 0, void 0, function* () {
    const { unMountRef } = formProp;
    const result = yield validateAdminAccountStatus(dispatch, values[fieldName], fieldName);
    if (unMountRef.current) {
        return;
    }
    const errorObject = { admin: result.error };
    if (result.error) {
        throw errorObject;
    }
});
export const proffitSearchAccountValidate = {
    admin: [
        ...validateEmail,
        (value, record, props) => {
            const { enableDomains } = props;
            return isNotIncludedEmailDomain(enableDomains, 'ドメインが異なるメールアドレスは登録できません')(value);
        },
        (value, record) => {
            const { billingInformation } = record;
            return billingInformation &&
                billingInformation.filter((v) => v.email === value).length > 0
                ? '請求書送付先（Cc）に同じメールアドレスが入力されています'
                : '';
        },
    ],
    email: [
        ...validateEmail,
        (value, record, props) => {
            const { changeExpiredStates, enableMembers } = props;
            // 期限切れのアカウントのメールアドレスはバリデーションとは別にチェック
            changeExpiredStates((prev) => (Object.assign(Object.assign({}, prev), { [value]: enableMembers
                    .filter((v) => v.isExpired)
                    .some((v) => v.email === value) })));
            return enableMembers
                .filter((v) => !v.isExpired)
                .some((v) => v.email === value)
                ? '既に登録されているメールアドレスです'
                : '';
        },
        (value, record) => {
            const { members } = record;
            return members && members.filter((v) => v.email === value).length > 1
                ? '同じメールアドレスが入力されています'
                : '';
        },
        (value, record, props) => {
            const { enableDomains } = props;
            return isNotIncludedEmailDomain(enableDomains, 'ドメインが異なるメールアドレスは登録できません')(value);
        },
    ],
    form: (values, dispatch, formProp, fieldName) => __awaiter(void 0, void 0, void 0, function* () {
        if (fieldName && fieldName.match(/members\[\d+]\.email/)) {
            yield memberValidate(values, dispatch, formProp, fieldName);
        }
        if (fieldName && fieldName === 'admin') {
            yield adminValidate(values, dispatch, formProp, fieldName);
        }
    }),
};
export default proffitSearchAccountValidate;
